var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Modal", {
    attrs: {
      title: _vm.$t("history.heading"),
      closeMessage: _vm.$t("history.close"),
      confirm: false,
      auto: "",
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("table", { staticClass: "table table-hover history-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { width: "30px" } }, [_vm._v("#")]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "80px" } }),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "80px" } }, [
                    _vm._v(_vm._s(_vm.$t("history.results"))),
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("history.pattern")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("history.filters")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("history.grouping")))]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "115px" } }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.recentHistory, function (entry, index) {
                  return _c(
                    "tr",
                    { key: entry.hash + (entry.interface.viewedResults || "") },
                    [
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(index + 1) + ".")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-muted",
                          staticStyle: { "padding-left": "0" },
                        },
                        [
                          _c("small", [
                            _vm._v(
                              _vm._s(
                                new Date(entry.timestamp).toLocaleString(
                                  "nl-NL",
                                  {
                                    hour12: false,
                                    //year: '2-digit',
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "numeric",
                                    minute: "numeric",
                                  }
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            entry.interface.viewedResults === "hits"
                              ? "Hits"
                              : entry.interface.viewedResults === "docs"
                              ? "Documents"
                              : entry.interface.viewedResults
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: {
                            title:
                              entry.displayValues.pattern.substring(0, 1000) ||
                              undefined,
                          },
                        },
                        [_vm._v(_vm._s(entry.displayValues.pattern))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: {
                            title:
                              entry.displayValues.filters.substring(0, 1000) ||
                              undefined,
                          },
                        },
                        [_vm._v(_vm._s(entry.displayValues.filters))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "history-table-contain-text",
                          attrs: { title: entry.view.groupBy.join(" ") || "-" },
                        },
                        [_vm._v(_vm._s(entry.view.groupBy.join(" ") || "-"))]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.load(entry)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("history.search")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [_c("span", { staticClass: "caret" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openShareUrl(entry)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("history.copyAsLink")))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.downloadAsFile(entry)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("history.downloadAsFile"))
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.remove(index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("history.delete")))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.clearHistoryVisible = true
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("history.deleteAll")))]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.recentHistory.length < _vm.history.length
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.shownOlderEntries += 5
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("history.loadMore")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSharingUrl
              ? _c(
                  "form",
                  {
                    staticClass: "history-popup",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        return _vm.closeShareUrl.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "history-popup-content modal-content" },
                      [
                        _c("input", {
                          ref: "shareUrlInput",
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            autofocus: "",
                            readonly: "",
                          },
                          domProps: { value: _vm.sharingUrl },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.clearHistoryVisible
              ? _c(
                  "Modal",
                  {
                    attrs: {
                      title: _vm.$t("history.clearSearchHistory"),
                      closeMessage: _vm.$t("history.cancel"),
                      confirmMessage: _vm.$t("history.clear"),
                      auto: "",
                    },
                    on: {
                      confirm: _vm.clearHistory,
                      close: function ($event) {
                        _vm.clearHistoryVisible = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(
                          _vm.$t("history.clearSearchHistoryConfirmation")
                        ) +
                        "\n\t\t"
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.importUrlVisible
              ? _c(
                  "form",
                  {
                    staticClass: "history-table-import-url",
                    attrs: { name: `${_vm.uid}_import` },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.importFromUrl.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "input-group",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("input", {
                          ref: "importUrlInput",
                          staticClass: "form-control",
                          attrs: {
                            type: "url",
                            autocomplete: "off",
                            autofocus: "",
                            placeholder: _vm.$t("history.copyUrlHere"),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-group-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.$t("history.importUrl")))]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.importUrlError
                      ? _c("div", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.importUrlError)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-open-import",
                    on: {
                      click: function ($event) {
                        _vm.importUrlVisible = !_vm.importUrlVisible
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fa fa-lg fa-plus" }),
                    _vm._v(" " + _vm._s(_vm.$t("history.importFromLink"))),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }